import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from './LanguageToggle';

// Shared site footer — identical markup/styling to the landing page footer.
// Relies on the .footer styles defined in LandingPage.css.
const SiteFooter = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">Brands Capital Group</div>
        <LanguageToggle />
        <div className="footer-right">{t('footer.copyright')}</div>
      </div>
    </footer>
  );
};

export default SiteFooter;
